module.exports = __webpack_public_path__ + "img/az.7a966a9.svg";